<div class="agent-card-view" [hidden]="retrievedCurrentView() !== viewType.cardView">
    <div class="row">
        <div class="col-12 align-items-center">
            <div #tooltipLoginName class="card-agent-name-overflow agent-name" [tooltip]="displayTooltip('loginName', supervisor?.GroupName)" placement="top" container="body" containerClass="cxone-agent-card-label-tooltip"
                (mouseenter)="isTextTruncated ? tooltip.show() : tooltip.hide()" 
                triggers="manual"
                #tooltip="bs-tooltip"
                (mouseleave)="tooltip.hide()"
                (wheel)="tooltip.hide()">
                <span>{{ supervisor?.GroupName }}</span>
            </div>
        </div>
    </div>
    <div class="row mb-1">
        <div class="col-12 align-items-center">
            <span class="agent-card-label">{{ getLocalizationString("Team", "Team") }}: </span>
            <div #tooltipTeam class="card-agent-name-overflow agent-card-text" [tooltip]="displayTooltip('team', supervisor?.TeamName)" placement="top" container="body" containerClass="cxone-agent-card-label-tooltip"
                (mouseenter)="isTextTruncated ? tooltipTeams.show() : tooltipTeams.hide()"
                triggers="manual"
                #tooltipTeams="bs-tooltip"
                (mouseleave)="tooltipTeams.hide()"
                (wheel)="tooltipTeams.hide()">
                <span>{{ supervisor?.TeamName }}</span>
            </div>
        </div>
    </div>
    <div class="d-flex flex-wrap flex-row">
        <div class="align-items-center total-games">
            <span class="agent-card-label">{{ getLocalizationString("Total_Games", "Total Games") }}: </span>
            <span class="agent-card-text"> {{ cvNumberLocalizePipe.transform(supervisor?.ActiveGameCount) }}</span>
        </div>
        <div class="align-items-center">
            <span #coinsTooltipText class="earning-text" containerClass="cxone-game-card-label-tooltip" container="body" placement="top">
                <span class="agent-card-label">{{ getLocalizationString("Earned_Coins", "Earned coins") }}: </span>
                <span class="text-nowrap align-items-center">
                    <svg class="icon-16 mr-1">
                        <use href="../../../App_Themes/CXone/icons/gamification/games/coin-reward.svg#coin-reward"></use>
                    </svg>
                    <span class="agent-card-text">{{ cvNumberLocalizePipe.transform(supervisor?.AvailableCoins) }}</span>
                </span>                
            </span>
        </div>
    </div>
    <div class="row">
        <div class="col-12">
            <sol-button [variant]="'basic'" [size]="'small'" class="ml-auto" (click)="updatedCurrentView()">
                <span class="pr-3 pl-3" cvLocalizedText langSection="Games_Module" langKey="See_More" class="line-height-buttom">See More</span>
            </sol-button>
        </div>
    </div>
</div>
<div *ngIf="retrievedCurrentView() === supervisor?.LoginID">
    <cxone-see-more [agent]="supervisor"></cxone-see-more>
</div>
